import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	position: relative;
`;

export const SectionLogo = styled.div`
	position: absolute;
	top: -30px;
	left: 50%;
	transform: translateX(-50%);
	width: 60px;
	height: 60px;
	background-color: ${tokens.color_primary};
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;

	& > svg {
		display: grid;
		place-items: center;
		width: 36px;
		height: 36px;

		& > path {
			fill: #fff;
		}
	}
`;

export const SkeletonContainer = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;

	div:nth-child(1) {
		position: absolute;
		top: -30px;
		left: 50%;
		transform: translateX(-50%);
	}

	div:nth-child(2) {
		margin: 54px 0 20px 0;
		display: flex;
		align-self: center;
	}

	div:nth-child(3) {
		height: 48px;
		display: flex;
		align-self: center;
	}

	div:nth-child(4) {
		margin: 50px 0;
		width: 60%;
		max-width: 1235px;
		display: flex;
		justify-content: flex-start;
	}
`;

export const AlertContainer = styled.div`
	display: flex;
	gap: 15px;
	justify-content: flex-start;
	padding-bottom: 40px;
`;
